import {getCookie, getCookieName} from '../../common/utils/cookieUtils'
import {ApiService} from '../ApiService'
import {SubmitXpertKnowledgeRatingBody} from '../XpertKnowledge/type'
import {
  CreateXpertKnowledgeTutorialBody,
  RequestChangesXpertKnowledgeTutorialBody,
  SubmitXpertKnowledgeTutorialBody,
  UpdateXpertKnowledgeTutorialBody,
  XpertKnowledgeTutorialDebugDto,
  XpertKnowledgeTutorialDto,
} from './type'

class XpertKnowledgeTutorialServiceProvider extends ApiService {
  async getAll(xpertKnowledgeId: string): Promise<XpertKnowledgeTutorialDto[]> {
    return this.get<XpertKnowledgeTutorialDto[]>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async getById(xpertKnowledgeId: string, tutorialId: number): Promise<XpertKnowledgeTutorialDto> {
    return this.get<XpertKnowledgeTutorialDto>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async create(xpertKnowledgeId: string, body: CreateXpertKnowledgeTutorialBody): Promise<XpertKnowledgeTutorialDto> {
    return this.post<XpertKnowledgeTutorialDto>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async update(xpertKnowledgeId: string, tutorialId: number, body: UpdateXpertKnowledgeTutorialBody): Promise<XpertKnowledgeTutorialDto> {
    return this.patch<XpertKnowledgeTutorialDto>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async submit(xpertKnowledgeId: string, tutorialId: number, body: SubmitXpertKnowledgeTutorialBody): Promise<XpertKnowledgeTutorialDto> {
    return this.patch<XpertKnowledgeTutorialDto>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}/submit`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async approve(xpertKnowledgeId: string, tutorialId: number): Promise<XpertKnowledgeTutorialDto> {
    return this.patch<XpertKnowledgeTutorialDto>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}/approve`, undefined, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async requestChanges(
    xpertKnowledgeId: string,
    tutorialId: number,
    body: RequestChangesXpertKnowledgeTutorialBody
  ): Promise<XpertKnowledgeTutorialDto> {
    return this.patch<XpertKnowledgeTutorialDto>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}/request-changes`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async dismissRequestChanges(xpertKnowledgeId: string, tutorialId: number): Promise<XpertKnowledgeTutorialDto> {
    return this.patch<XpertKnowledgeTutorialDto>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}/dismiss-request-changes`, undefined, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async dismissReview(xpertKnowledgeId: string, tutorialId: number): Promise<XpertKnowledgeTutorialDto> {
    return this.patch<XpertKnowledgeTutorialDto>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}/dismiss-review`, undefined, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async downgrade(xpertKnowledgeId: string, tutorialId: number): Promise<XpertKnowledgeTutorialDto> {
    return this.patch<XpertKnowledgeTutorialDto>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}/downgrade`, undefined, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async submitRating(body: SubmitXpertKnowledgeRatingBody): Promise<XpertKnowledgeTutorialDto> {
    return this.post<XpertKnowledgeTutorialDto>(`/xpert-knowledge/rating`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async debug(xpertKnowledgeId: string, tutorialId: number): Promise<XpertKnowledgeTutorialDebugDto> {
    return this.get<XpertKnowledgeTutorialDebugDto>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}/debug`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }
}

export const XpertKnowledgeTutorialService = new XpertKnowledgeTutorialServiceProvider()
